/**
 * Construit le libellé « <année> (<editionId>) » du header d'une proposition groupée.
 *
 * Dans la vue groupée, `firstProposal` est la proposition la plus confiante du groupe ;
 * son champ dénormalisé `editionYear` peut diverger de l'editionId réel du groupe
 * (ex. proposition de duplication). On priorise donc l'année résolue côté API
 * (`metaEditionYear`, issue d'un lookup de l'édition liée) qui fait autorité.
 */
export function getGroupEditionLabel(
  editionId: string | number | null | undefined,
  metaEditionYear: number | string | null | undefined,
  fallbackYear: string | undefined
): string | undefined {
  if (editionId === undefined || editionId === null || editionId === '') {
    return undefined
  }

  const year =
    metaEditionYear !== undefined && metaEditionYear !== null
      ? metaEditionYear.toString()
      : fallbackYear

  return year ? `${year} (${editionId})` : `Edition ID: ${editionId}`
}
